export default angular
    .module('syVideoPlayer', [])
    /**
     * @ngdoc controller
     * @name syVideoPlayer.controller:videoControllerForm
     * @description
     * Scope for a video player
     */
    // @ngInject
    .controller('videoControllerForm', [
        '$sce',
        '$timeout',
        function ($sce, $timeout) {
            var controller = this
            var videoUrl = ''
            var isPlaying = false
            var playerParameters = '?rel=0&amp;autoplay=1&amp;showinfo=0&amp;wmode=transparent&amp;enablejsapi=1'

            // Create a trusted URL object (SCE) with our default YouTube params
            this.makeTrustedUrl = function (url) {
                return $sce.trustAsResourceUrl(url + playerParameters)
            }

            // Gets the video url.
            this.getVideoUrl = function () {
                return videoUrl
            }

            // Sets the video url.
            this.setVideoUrl = function (url) {
                videoUrl = url ? controller.makeTrustedUrl(url) : ''
            }

            // Gets the is playing flag.
            this.getIsPlaying = function () {
                return isPlaying
            }

            // Sets the is playing flag.
            this.setIsPlaying = function (value) {
                isPlaying = value ? value : false
            }

            // Plays the video. (i.e. set the is playing flag to true)
            this.playVideo = function () {
                $timeout(function () {
                    controller.setIsPlaying(true)
                })
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syVideoPlayer.directive:syVideoPlayerContainer
     * @description
     * Links the controller to the main container of the video player.
     */
    // @ngInject
    .directive('syVideoPlayerContainer', [
        function () {
            return {
                scope: true,
                controller: 'videoControllerForm'
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syVideoPlayer.directive:syVideoPlayer
     * @description
     * Add functionality to a video player element
     */
    // @ngInject
    .directive('syVideoPlayer', [
        function () {
            return {
                restrict: 'E',
                replace: true,
                template:
                    '<iframe id="video-player-embed" class="video-player-embed" ng-if="getIsPlaying()" ng-src="{{getVideoUrl()}}" frameborder="0" allowfullscreen></iframe>',
                require: '^^syVideoPlayerContainer',
                link: function ($scope, $element, attrs, controller) {
                    $scope.getVideoUrl = controller.getVideoUrl
                    $scope.getIsPlaying = controller.getIsPlaying
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syVideoPlayer.directive:syVideoPreview
     * @description
     * Links the controller to the play button.VideoAdobeAnalyticsService
     */
    // @ngInject
    .directive('syVideoPlayerButton', [
        function () {
            return {
                require: '^^syVideoPlayerContainer',
                link: function ($scope, $element, attrs, controller) {
                    if (attrs.videoUrl) {
                        controller.setVideoUrl(attrs.videoUrl)
                        $element.on('click', function (e) {
                            e.preventDefault()
                            controller.playVideo()
                        })
                    }
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syVideoPlayer.directive:videoPlayerEmbed
     * @description
     * Watch for changing YouTube IFRAME src changes
     */
    // @ngInject
    .directive('videoPlayerEmbed', [
        'VideoAdobeAnalyticsService',
        function (VideoAdobeAnalyticsService) {
            return {
                restrict: 'C',
                link: function ($scope, $element, attrs) {
                    attrs.$observe('ngSrc', function () {
                        VideoAdobeAnalyticsService.registerPlayer($element)
                    })
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syVideoPlayer.directive:iframe
     * @description
     * Watch for changing YouTube IFRAME src changes
     */
    // @ngInject
    .directive('iframe', [
        'VideoAdobeAnalyticsService',
        function (VideoAdobeAnalyticsService) {
            return {
                restrict: 'E',
                link: function ($scope, $element, attrs) {
                    if (attrs.src && attrs.src.indexOf('youtube') >= 0) {
                        VideoAdobeAnalyticsService.registerPlayer($element)
                    }
                }
            }
        }
    ])
